import PazienteMisurazioni from "../";

const routes = [
    { name: "PazienteDashboard", path: "/paziente/dashboard", component: PazienteMisurazioni.Dashboard, meta: { title: "Dashboard" } },
    { name: "PazienteMisurazioniExportList", path: "/paziente/exportmisurazioni", component: PazienteMisurazioni.PazienteMisurazioniExportList, meta: { title: "Paziente Misurazioni Export List" } },
];

export default routes;
